/* Endora — PDP galerisinde parmakla kaydirma (Gorev 6'nin ertelenen parcasi)
 *
 * Mobilde kucuk resimler serit gostergesine donusturuldugu icin gorseller
 * arasinda yalnizca seride dokunarak geciliyordu. Bu dosya ayni gecisi
 * ANA GORSEL uzerinde saga/sola kaydirmayla da yapar.
 *
 * NEDEN AYRI DOSYA: gecis mantigi sections/main-product.liquid icindeki
 * gorselDegistir() fonksiyonunda. Ona disaridan erisilemez ama kucuk resim
 * DUGMESINE click gondermek ayni yolu calistirir; boylece is-active durumu,
 * serit gostergesi ve srcset tek yerden yonetilmeye devam eder. Bu sayede
 * main-product.liquid'e hic dokunulmaz (dosya uzerinde baska bir gelistirici
 * calisiyor, catisma riski var).
 *
 * KENARLARDA DONMEZ: serit bir konum gostergesi; son gorselden basa atlamak
 * gostergeyle celisirdi. Uclarda kaydirma sessizce yok sayilir.
 */
(function () {
  'use strict';

  var ESIK = 45;      // yatay hareket bu pikselden azsa kaydirma sayilmaz
  var ORAN = 1.4;     // yatay hareket dikeyin bu kati olmali (sayfa kaydirmayla karismasin)
  var SURE = 700;     // ms — daha uzun surenler surukleme degil, dokunup bekleme sayilir

  function kur(kok) {
    var sahne = kok.querySelector('.pdp-gallery__main');
    var thumbs = kok.querySelectorAll('[data-pdp-thumb]');
    if (!sahne || thumbs.length < 2 || sahne.hasAttribute('data-kaydir')) return;
    sahne.setAttribute('data-kaydir', '');

    var x0 = 0, y0 = 0, t0 = 0, izli = false;

    sahne.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { izli = false; return; }
      izli = true;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = e.timeStamp;
    }, { passive: true });

    sahne.addEventListener('touchend', function (e) {
      if (!izli) return;
      izli = false;
      var d = e.changedTouches[0];
      var dx = d.clientX - x0, dy = d.clientY - y0;
      if (e.timeStamp - t0 > SURE) return;
      if (Math.abs(dx) < ESIK || Math.abs(dx) < Math.abs(dy) * ORAN) return;

      var simdi = 0;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) { simdi = i; break; }
      }
      var hedef = dx < 0 ? simdi + 1 : simdi - 1;
      if (hedef < 0 || hedef >= thumbs.length) return;   // uclarda donme yok

      var gorsel = kok.querySelector('[data-pdp-ana-gorsel]');
      if (gorsel) {
        gorsel.classList.remove('pdp-kaydi--sol', 'pdp-kaydi--sag');
        // reflow: ayni sinif art arda eklendiginde animasyon yeniden baslasin
        void gorsel.offsetWidth;
        gorsel.classList.add(dx < 0 ? 'pdp-kaydi--sol' : 'pdp-kaydi--sag');
      }
      thumbs[hedef].click();
      thumbs[hedef].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }, { passive: true });
  }

  function tara() {
    var g = document.querySelectorAll('.pdp-main, .shopify-section--main-product');
    for (var i = 0; i < g.length; i++) kur(g[i]);
    if (!g.length) kur(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tara);
  else tara();
  document.addEventListener('shopify:section:load', tara);
})();
